import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './OTP.css';

const OTP: React.FC = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [mobileNumber, setMobileNumber] = useState('+961 70 123 456'); // This would come from registration

  const handleOtpChange = (index: number, value: string) => {
    if (value.length > 1) return;
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto focus next input
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      prevInput?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').slice(0, 6);
    if (/^\d+$/.test(pastedData)) {
      const newOtp = pastedData.split('').concat(Array(6 - pastedData.length).fill(''));
      setOtp(newOtp.slice(0, 6));
    }
  };

  const handleVerify = () => {
    const otpCode = otp.join('');
    if (otpCode.length === 6) {
      // Verify OTP logic here
      console.log('Verifying OTP:', otpCode);
      // After verification, set flag to show interests popup
      sessionStorage.setItem('showInterests', 'true');
      // Navigate to home
      navigate('/');
    }
  };

  const handleResend = () => {
    // Resend OTP logic
    console.log('Resending OTP');
    setOtp(['', '', '', '', '', '']);
  };

  const isOtpComplete = otp.every(digit => digit !== '');

  return (
    <div className="otp-page">
      <div className="otp-container">
        <button className="otp-back-button" onClick={() => navigate('/login')}>
          ← Back
        </button>

        <div className="otp-header">
          <div className="otp-icon">🔐</div>
          <h1>تأكيد الحساب</h1>
          <p className="otp-message">
            تم إرسال رمز التحقق إلى رقمك
            <br />
            <strong>{mobileNumber}</strong>
          </p>
        </div>

        <div className="otp-input-container">
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-${index}`}
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={digit}
              onChange={(e) => handleOtpChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              onPaste={index === 0 ? handlePaste : undefined}
              className="otp-input"
              autoFocus={index === 0}
            />
          ))}
        </div>

        <button
          className={`verify-button ${isOtpComplete ? 'active' : ''}`}
          onClick={handleVerify}
          disabled={!isOtpComplete}
        >
          تأكيد
        </button>

        <div className="otp-footer">
          <p>لم تستلم الرمز؟</p>
          <button className="resend-button" onClick={handleResend}>
            إعادة الإرسال
          </button>
        </div>
      </div>
    </div>
  );
};

export default OTP;

